const API_PUBLIC_KEY = 'QWMerD';
const NEWSLETTER_LIST_ID = 'WbYSm2';

class PreorderModal extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.preorder-modal-overlay');
    this.btnClose = this.querySelector('.preorder-modal-header-close');
    this.titleEl = this.querySelector('.preorder-modal-header-title');
    this.successMessage = this.querySelector(
      '.preorder-modal-content-success-message',
    );
    this.variantPicker = this.querySelector(
      '#preorder-modal-content-variant-picker',
    );
    this.emailInput = this.querySelector('#preorder-modal-content-email');
    this.newsletterInput = this.querySelector('#back-in-stock-newsletter');
    this.form = this.querySelector('form#preorder');
    document.addEventListener('preorder-modal:open', this.onLoadData);
    this.btnClose.addEventListener('click', this.closeModal);
    this.overlay.addEventListener('click', this.closeModal);
    this.form.addEventListener('submit', this.onSubmitForm);
  }

  onLoadData = async (e) => {
    const productData = await this.getProductData(e.detail.handle);
    if (!productData) {
      return;
    }
    this.variantPicker.innerHTML = '';
    productData.variants.forEach((variant) => {
      const newOptionEl = document.createElement('option');
      newOptionEl.value = variant.id;
      newOptionEl.innerText = variant.title;
      this.variantPicker.appendChild(newOptionEl);
    });
    this.titleEl.innerText = this.capitalizeText(
      productData.title.toLowerCase(),
    );
    this.openModal();
  };

  openModal = () => {
    this.classList.remove('hide');
    if (!this.emailInput) {
      return;
    }
    this.emailInput.value = '';
    if (!this.newsletterInput) {
      return;
    }
    this.newsletterInput.checked = true;
    if (!this.successMessage) {
      return;
    }
    // this.successMessage.innerHTML = '';
    this.successMessage.classList.add('hide');
  };

  closeModal = () => {
    this.classList.add('hide');
  };

  onSubmitForm = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const formObject = Object.fromEntries(formData.entries());

    const bisResponse = await this.submitKlaviyoBackInStockSubscription({
      email: formObject.email,
      variantId: formObject.variant,
    });

    const newsletterResponse =
      formObject.newsletter === 'on'
        ? await this.submitKlaviyoNewsletterSubscription({
            email: formObject.email,
          })
        : true;

    if (bisResponse && newsletterResponse) {
      this.showSuccessMessage();
    }
  };

  showSuccessMessage = () => {
    if (!this.successMessage) {
      return;
    }

    this.successMessage.classList.remove('hide');
  };

  submitKlaviyoBackInStockSubscription = async ({ email, variantId }) => {
    try {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-07-15',
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(payload),
      };

      const backInStockSubscription = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${API_PUBLIC_KEY}`,
        requestOptions,
      ).then((result) => result);

      return backInStockSubscription.ok || false;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  submitKlaviyoNewsletterSubscription = async ({ email }) => {
    try {
      const formData = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: NEWSLETTER_LIST_ID,
              },
            },
          },
        },
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${API_PUBLIC_KEY}`,
        {
          method: 'POST',
          headers: {
            revision: '2024-07-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify(formData),
        },
      ).then((response) => response);

      return response.ok || false;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  getProductData = async (handle) => {
    try {
      const productData = await fetch(`/products/${handle}.js`).then((res) =>
        res.json(),
      );
      return productData || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  capitalizeText = (text) => {
    return text.replace(/\b\w/g, (char) => char.toUpperCase());
  };
}

if (!customElements.get('preorder-modal')) {
  customElements.define('preorder-modal', PreorderModal);
}

class PreorderOpener extends HTMLElement {
  constructor() {
    super();
    this.btnPreorder = this.querySelector(
      'button.back-in-stock:not(.back-in-stock-secondary)',
    );
    this.btnBackInStock = this.querySelector(
      'button.back-in-stock.back-in-stock-secondary',
    );
    this.btnAddToCart = this.querySelector('button.add-to-cart');
    this.handle = this.getAttribute('data-handle');
    this.checkVariantChange =
      this.getAttribute('data-check-variant-change') === 'true';

    if (this.btnPreorder && this.handle) {
      this.btnPreorder.addEventListener('click', this.openModal);
    }
    if (this.checkVariantChange && this.btnBackInStock && this.handle) {
      document.addEventListener(
        'back-in-stock:checkAvailability',
        this.onVariantChange,
      );
      this.btnBackInStock.addEventListener('click', this.openModal);
    }

    document.addEventListener(
      'preorder-opener:show-preorder',
      this.onShowPreorder,
    );
    document.addEventListener(
      'preorder-opener:show-add-to-cart',
      this.onShowAddToCart,
    );

    this.init();
  }

  init = () => {
    if (this.btnPreorder && window?.Shopify?.backInStock?.state === 'waiting') {
      this.onShowPreorder();
    } else if (
      this.btnAddToCart &&
      window?.Shopify?.backInStock?.state === 'done'
    ) {
      this.onShowAddToCart();
    }
  };

  onShowAddToCart = () => {
    if (this.btnAddToCart) {
      this.btnAddToCart.classList.remove('hide', 'btn--loading');
    }
    if (this.btnPreorder) {
      this.btnPreorder.classList.add('hide');
    }
  };

  onShowPreorder = () => {
    if (this.btnAddToCart) {
      this.btnAddToCart.classList.add('hide');
    }
    if (this.btnPreorder) {
      this.btnPreorder.classList.remove('hide', 'btn--loading');
    }
  };

  onVariantChange = (e) => {
    if (!this.btnBackInStock) {
      return;
    }
    if (e.detail.variant_available) {
      this.btnBackInStock.classList.add('hide');
    } else {
      this.btnBackInStock.classList.remove('hide');
    }
  };

  openModal = () => {
    document.dispatchEvent(
      new CustomEvent('preorder-modal:open', {
        detail: {
          handle: this.handle,
        },
      }),
    );
  };
}

if (!customElements.get('preorder-opener')) {
  customElements.define('preorder-opener', PreorderOpener);
}
